import React, { useEffect, useState } from 'react';

import LateralPanel from '../../../../muiComponents/LateralPanel';
import Title from '../Title';
import Icon from '../../../../muiComponents/Icon';
import {
    usePropertyComplementaryData,
    usePropertyImagesDetail,
} from '../../../contextsProperty/ContextProperties';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import ImageDropZone from '../ImageDropZone';
import {
    IMAGE_INITIAL_STATE,
    IMAGE_MAX_SIXE_ALLOWED_MB,
    IMAGE_MAX_SIZE_ALLOWED,
    imageSmallColumnGrid,
    MIN_IMAGE_HEIGHT,
    MIN_IMAGE_WIDTH,
} from '../../../../utils/property/propertyUtils';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import { ComplementaryImageTypeState } from '../../../../types/properties/propertyTypes';
import { getRandomNumber } from '../../../../utils/usefulFunctions';
import GridChild from '../../../../muiComponents/GridChild';
import Grid from '../../../../muiComponents/Grid';
import ImageCard from './ImageCard';
import { Alert } from '@mui/material';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../utils/commonVariables/grid';

interface AddImagesPanelProps {
    open?: boolean;
}

const AddImagesPanel = (props: AddImagesPanelProps) => {
    const { open } = props;
    const translate = useTranslate();
    const { hotelImagesTypeList } = usePropertyComplementaryData();
    const {
        images,
        togglePanelOpen,
        addImagesToDetail,
        deleteImagesFromDetail,
        category,
        isDropdownVisible,
        setImagesDetailCategory,
        resetImageDatailData,
        saveDetailImagesToDDBB,
        isLoading,
    } = usePropertyImagesDetail();
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        return () => {
            resetImageDatailData();
        };
    }, []);

    return (
        <>
            <LateralPanel open={open} className='property__image-panel'>
                <header className='flex flex-between flex-align-center padding-inline50'>
                    <Title text='add_images' className='text-secondary-color' />
                    <Icon
                        iconName='Close'
                        className='cursor-pointer'
                        onClick={() =>
                            isLoading ? null : togglePanelOpen(false)
                        }
                    />
                </header>
                <main className='flex-column gap-30 height100perc overflow-y-auto padding-inline50'>
                    {isDropdownVisible ? (
                        <LoadedOptionsTypeahead
                            labelText='image_category'
                            options={hotelImagesTypeList}
                            optionsLabelKey={'name'}
                            idValueKey='id'
                            value={category}
                            handleChange={(
                                _event: React.SyntheticEvent,
                                value: ComplementaryImageTypeState | null
                            ) => {
                                setImagesDetailCategory(value);
                            }}
                            className='margin-top10'
                        />
                    ) : (
                        ''
                    )}

                    {isLoading ? (
                        <LoadingPlaceholder
                            variant='rounded'
                            width={'100%'}
                            height={200}
                        />
                    ) : (
                        <>
                            <ImageDropZone
                                disabled={isDropdownVisible ? !category : false}
                                disabledMessage='image_category_first'
                                maxSizeAllowed={IMAGE_MAX_SIZE_ALLOWED}
                                maxSizeAllowedMB={IMAGE_MAX_SIXE_ALLOWED_MB}
                                minWidthAllowed={MIN_IMAGE_WIDTH}
                                minHeightAllowed={MIN_IMAGE_HEIGHT}
                                uploadFiles={(files: File[]) => {
                                    const filesWithPreview = files.map(
                                        (file: File) => ({
                                            ...IMAGE_INITIAL_STATE,

                                            id: `-${getRandomNumber(1, 999)}`,
                                            caption: file.name,
                                            published: true,
                                            idType: category?.id
                                                ? parseInt(category?.id)
                                                : 0,
                                            type: category?.nameKey || '',
                                            url: URL.createObjectURL(file),
                                            file: file,
                                        })
                                    );
                                    addImagesToDetail(filesWithPreview);
                                }}
                                setErrorMessage={(message: string) => {
                                    setErrorMessage(message);
                                }}
                            />
                            {errorMessage ? (
                                <Alert
                                    severity='error'
                                    onClose={() => setErrorMessage('')}
                                >
                                    {errorMessage}
                                </Alert>
                            ) : (
                                ''
                            )}
                            {images.length ? (
                                <Grid
                                    columnSpacing={gridSpacing30}
                                    rowSpacing={gridSpacing40}
                                    style={{ width: 'unset' }}
                                >
                                    {images.map((img, ind) => (
                                        <GridChild
                                            gridProps={imageSmallColumnGrid}
                                            key={img?.id || ind}
                                        >
                                            <ImageCard
                                                image={img}
                                                onDelete={(id: string) =>
                                                    deleteImagesFromDetail(id)
                                                }
                                                isToolbarVisible={false}
                                            />
                                        </GridChild>
                                    ))}
                                </Grid>
                            ) : (
                                ''
                            )}
                        </>
                    )}
                </main>

                <footer
                    className={`flex ${
                        images.length ? 'flex-between' : 'flex-end'
                    } padding-inline50`}
                >
                    {images.length > 0 && (
                        <Button
                            variant='contained'
                            className={isLoading ? '' : 'delete-button'}
                            disabled={isLoading}
                            onClick={() => {
                                deleteImagesFromDetail();
                            }}
                        >
                            {translate('delete_all_images')}
                        </Button>
                    )}

                    <div className='flex gap-20'>
                        <Button
                            variant='outlined'
                            disabled={isLoading}
                            onClick={() => togglePanelOpen(false)}
                        >
                            {translate('cancel')}
                        </Button>
                        <Button
                            variant='contained'
                            disabled={isLoading}
                            onClick={() => {
                                saveDetailImagesToDDBB();
                            }}
                        >
                            {translate('save')}
                        </Button>
                    </div>
                </footer>
            </LateralPanel>
        </>
    );
};

export default AddImagesPanel;
